import { UserProfile } from "../../auth/types";

export function parseFirstName(profile?: UserProfile): string {
  return profile?.firstName ?? "";
}

export function parseLastName(profile?: UserProfile): string {
  return profile?.lastName ?? "";
}

export function parseFullName(profile?: UserProfile): string {
  let name = "";
  if (!profile) return name;
  name = profile.firstName ?? "";
  if (profile.lastName) {
    name += " " + profile.lastName;
  }
  return name;
}

export function parseInitials(profile?: UserProfile): string {
  let initials = "";
  if (!profile) return initials;
  (profile.firstName ?? "").charAt(0);
  if (profile.lastName) {
    initials += profile.lastName.charAt(0);
  }
  return initials;
}
